import * as common from './common';
import * as stage from './stage';

export { bundleConfig } from './dev';

export const sharedEnvConfig = (window.sharedEnvConfig = {
  ...stage.sharedEnvConfig,
  ...window.sharedEnvConfig,
  'cookie.options': {
    domain: '.minecraft.net',
    secure: true
  },
  reCaptcha: {
    sitekey: ''
  },
  'url.setUpProfile': `https://msa-migration.aem-apps.minecraft.net/${common.language}/set-profile-name/`,
  /* eslint-disable */
  telemetryFn: function (metadata: import('@mojang/telemetry').IMetadata, data: any) {
    console.log('🔥', metadata, data);
  }
  /* eslint-enable */
});

export const msaMigrationConfig = (window.msaMigrationConfig = {
  ...common.msaMigrationConfig,
  ...window.msaMigrationConfig,
  'url.xboxUpsellReturnUrl': 'https://sisu.aem-apps.minecraft.net',
  'url.xboxLoginReturnUrl': 'https://sisu.aem-apps.minecraft.net',
  'url.xboxRegisterReturnUrl': 'https://sisu.aem-apps.minecraft.net',
  environmentName: 'msa-migration'
});

export const buyMinecraftLoginConfig = (window.buyMinecraftLoginConfig = {
  ...window.buyMinecraftLoginConfig,
  'endpoint.pdpUrl': `https://msa-migration.aem-apps.minecraft.net/${common.language}/store/minecraft-java-edition`,
  'url.purchaseReciept': `https://msa-migration.aem-apps.minecraft.net/${common.language}/minecraft-java/setup/receipt/`,
  'url.xboxPurchaseLoginReturnUrl': `https://msa-migration.aem-apps.minecraft.net/${common.language}/store/minecraft-java-edition/buy`
});

export const profileRedeemCodeConfig = (window.profileRedeemCodeConfig = {
  ...window.profileRedeemCodeConfig,
  'url.login': `https://msa-migration.aem-apps.minecraft.net/${common.language}/login`
});
